import { render, staticRenderFns } from "./emailDetail.vue?vue&type=template&id=97022d8e&scoped=true&"
import script from "./emailDetail.vue?vue&type=script&lang=js&"
export * from "./emailDetail.vue?vue&type=script&lang=js&"
import style0 from "./emailDetail.vue?vue&type=style&index=0&id=97022d8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97022d8e",
  null
  
)

export default component.exports